export const isEmailValid = (value: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !!(value && emailRegex.test(value));
};

export const isPasswordValid = (value: string): boolean =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\S]{8,}$/.test(value);

export const isAbsoluteUrl = (url: string): boolean => {
  return /^(https?:\/\/|\/\/)/.test(url) || url.startsWith('mailto:') || url.startsWith('tel:');
};

export const formatDate = (date: string): string => new Date(date).toLocaleDateString();
